import { requestAjax } from '@/api/user'
import {
  getToken,
  setToken,
  removeToken,
  setUserUUID,
  removeUserUUID,
  removeIsDeveloper,
  setUserInfo,
  getUserInfo,
  removeUserInfo,
  getNickname,
  setNickname,
  removeNickname,
  isLogin,
  setPlatformUuid,
  removePlatformUuid,
  setPlatformName,
  removePlatformName,
  setHasPackage,
  removeHasPackage,
  setIsBasic,
  removeIsBasic,
  setIsAuthOfficial,
  removeIsAuthOfficial,
  setIsOver,
  removeIsOver,
  setSnapshotId,
  removeSnapshotId,
  setHeadImg,
  removeHeadImg,
  setPlatformUuidKfc,
  removePlatformUuidKfc,
  setPlatformNameKfc,
  removePlatformNameKfc,
  setHeadImgKfc,
  removeHeadImgKfc,
  setIsAuthKfc,
  getIsAuthKfc,
  removeIsAuthKfc,
  setIsDeveloper,
  getIsDeveloper
} from '@/utils/auth'
import official from '@/javaApi/official'
const officialModel = new official()

const state = {
  isSaasProxyUser: 0, //是否为saas小程序
  isDyAppOwner: 0,// 是否为小程序主
  token: getToken(),
  avatar: '',
  nickname: getNickname(),
  userInfo: getUserInfo(),
  isLogin: isLogin(),
  platformUuid: 0,//公众号uuid
  platformName: '',//公众号名称
  isBasic: true,//false为分销版
  hasPackage: false,//是否已购买套餐
  isAuthOfficial: false,//是否绑定公众号
  isOver: 1,//套餐是否过期
  snapshotId: 0, //套餐快照ID（用户购买的未授权的套餐快照）
  isDeveloper: getIsDeveloper() === 'true' ? true : false, // 是否是开放平台开发者
  appKey: [],
  showAppKey: {},
  curentPhoneNumber:'', //手机号
}

const mutations = {
  // 设置平台类型
  SET_APP_TYPE(state, val) {
    console.log(val, 'SET_APP_TYPE')
    state.isSaasProxyUser = val.isSaasProxyUser
    state.isDyAppOwner = val.isDyAppOwner
  },
  SET_appKey: (state, key) => {
    state.appKey = key
  },
  SET_showAppKey: (state, key) => {
    state.showAppKey = key
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NICKNAME: (state, nickname) => {
    state.nickname = nickname
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_USERINFO: (state, data) => {
    state.userInfo = data
  },
  SET_ISLOGIN: (state, data) => {
    state.isLogin = data
  },
  SET_IS_DEVELOPER: (state, isDeveloper) => {
    state.isDeveloper = isDeveloper
  },
  // 手机号
  SET_PHONE_NUMBER: (state, phoneNumber) => {
    state.curentPhoneNumber = phoneNumber
  }
}

const actions = {
  changeAppKey({ commit }, appKey) {
    commit('SET_appKey', appKey)
  },
  changeAppName({ commit }, appName) {
    commit('SET_appName', appName)
  },
  // user login
  login({ commit }, userInfo) {
    let url = window.location.href.split('?')[0]
    let domain = url.split('//')[1].split('/')[0]
    const {
      mobile,
      password
    } = userInfo
    return new Promise((resolve, reject) => {
      var data = {
        mobile: mobile,
        password: password,
        domain
      }
      requestAjax(data, '/index/user/login', 'post').then(response => {
        
        const { data } = response
        const isDeveloper = data.userInfo.is_developer == 1 ? true : false
        console.log(isDeveloper)
        commit('SET_ISLOGIN', true);
        // 存储手机号
        commit('SET_PHONE_NUMBER',data.userInfo.mobile)
        // commit('SET_APP_TYPE', {
        //   isSaasProxyUser: data.userInfo.is_saas_proxy_user,
        //   isDyAppOwner: data.userInfo.is_dy_app_owner
        // })
        commit('SET_TOKEN', data.token)
        commit('SET_IS_DEVELOPER', isDeveloper)
        commit('SET_NICKNAME', data.userInfo.nickname)
        window.localStorage.setItem('openUserInfo', JSON.stringify({
          avatar: data.userInfo.avatar,
          nickname: data.userInfo.nickname,
          leadUUID: data.userInfo.leadUUID,
          is_open_tiktok_permission: data.userInfo.is_open_tiktok_permission,
          is_saas_proxy_user:data.userInfo.is_saas_proxy_user
        }))
        setIsDeveloper(isDeveloper)
        setNickname(data.userInfo.nickname)
        setToken(data.token)
        setUserUUID(data.userUUID)
        resolve(response)
        localStorage.setItem('isErrorTip', 0)
        localStorage.setItem('java-token', data.javaToken)
        localStorage.setItem('java-open-token', data.javaOpenToken)
        localStorage.setItem('userUUID', data.userUUID)
        //获取开放平台用户已购套餐与公众号信息（第一条已授权的公众号数据为默认公众号，如过没有授权则取第一条）
        officialModel.publicLogin({ openUserUuid: data.userUUID }).then((response) => {
          console.log(response)
          setPlatformUuid(state.platformUuid);
          setPlatformName(state.platformName)
          setSnapshotId(state.snapshotId)
          setIsOver(state.isOver)
          setIsBasic(state.isBasic)
          setHasPackage(state.hasPackage)
          setIsAuthOfficial(state.isAuthOfficial)
          var res = response.data
          if (res.code != 200) {
            that.$Message.error(res.message)
            return
          }
          if (res.data.binds.length > 0) {
            var defaultOfficial = {}
            let i;
            let tempData;
            for (i = 0; i < res.data.binds.length; i++) {
              tempData = res.data.binds[i]
              if (tempData['id'] > 0) {
                defaultOfficial = tempData
                break;
              }
            }
            if (!defaultOfficial.id) {
              let lastOfficial = res.data.binds.length
              defaultOfficial = res.data.binds[lastOfficial - 1];
            }
            if (defaultOfficial.platformUuid) {
              setPlatformUuid(defaultOfficial.platformUuid);
            }
            if (defaultOfficial.platformName) {
              setPlatformName(defaultOfficial.platformName);
            }

            if (defaultOfficial.snapshotId) {
              setSnapshotId(defaultOfficial.snapshotId)
            } else {
              setSnapshotId(0)
            }
            setIsOver(defaultOfficial.isOver)
            setHeadImg(defaultOfficial.headImg)
            if (defaultOfficial.isProfit === 1) {
              setIsBasic(false)
            } else {
              setIsBasic(true)
            }
            if (defaultOfficial.packageName !== null) {
              setHasPackage(true)
            } else {
              setHasPackage(false)
            }
            if (defaultOfficial.platformUuid !== '' && defaultOfficial.platformName !== '') {
              setIsAuthOfficial(true)
            } else {
              setIsAuthOfficial(false)
            }
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
        // 获取肯德基公众号信息，默认取第一条数据为默认公众号
        officialModel.getAuthPublicList({ openUserUuid: data.userUUID }).then((response) => {
          var res = response.data
          if (res.success) {

            if (res.data && res.data.binds && res.data.binds.length > 0) {
              this.publicList = res.data.binds
              // 取第一条公众号数据，做为默认公众号
              var defaultKfc = res.data.binds[0];
              setPlatformUuidKfc(defaultKfc.platformUuid) // 公众号UUID
              setPlatformNameKfc(defaultKfc.platformName) // 公众号名称
              setHeadImgKfc(defaultKfc.headImg) // 公众号logo
              // 公众号是否已授权
              if (defaultKfc.platformUuid !== '' && defaultKfc.platformName !== '') {
                setIsAuthKfc(true)
              } else {
                setIsAuthKfc(false)
              }
              this.$store.dispatch('kfc/changePlatformNameKfc', defaultKfc.platformName)
              this.$store.dispatch('kfc/changeHeadImgKfc', defaultKfc.headImg)
            }
          }
        }).catch(error => {
          reject(error)
        })
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({
    commit
  }) {
    return new Promise((resolve, reject) => {
      requestAjax({}, '/index/user/userInfo', 'post').then(response => {
        const {
          data
        } = response
        commit('SET_USERINFO', data)
        setUserInfo(data)
        commit('SET_ISLOGIN', true);
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({
    commit
  }) {
    commit('SET_TOKEN', '')
    commit('SET_USERINFO', {})
    commit('SET_ISLOGIN', false);
    commit('SET_IS_DEVELOPER', false);
    commit('SET_appKey', [])
    commit('SET_showAppKey', {})
    removeUserUUID()
    removeIsDeveloper()
    removeToken()
    removeUserInfo()
    removePlatformUuid()
    removePlatformName()
    removeHasPackage()
    removeIsBasic()
    removeIsAuthOfficial()
    removeIsOver()
    removeSnapshotId()
    removeNickname()
    removeHeadImg()
    removePlatformUuidKfc()
    removePlatformNameKfc()
    removeHeadImgKfc()
    removeIsAuthKfc()

  },

  // remove token
  resetToken({
    commit
  }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      removeUserUUID()
      removeIsDeveloper()
      removePlatformUuid()
      removePlatformName()
      removeHasPackage()
      removeIsBasic()
      removeIsAuthOfficial()
      removeIsOver()
      removeSnapshotId()
      removeNickname()
      removeHeadImg()
      resolve()
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js